import { render } from "./DeliveryVideoModal.vue?vue&type=template&id=c8306b22"
import script from "./DeliveryVideoModal.vue?vue&type=script&lang=js"
export * from "./DeliveryVideoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__